import type { Api, coreModuleName, reactHooksModuleName } from "@reduxjs/toolkit/query/react";
import type { baseQueryGraphql } from "~/services/baseApi";

import { apiEndpoints } from "~/services/endpoints/apiEndpoints";

type ApiTagType = typeof apiEndpoints extends Api<infer _B, infer _D, infer _R, infer T, infer _M> ? T : never;

// Injecting into the full api re-maps hook names over all ~940 endpoints per site; this base carries no definitions.
const injectionBase = apiEndpoints as unknown as Api<
	typeof baseQueryGraphql,
	Record<never, never>,
	"api",
	ApiTagType,
	typeof coreModuleName | typeof reactHooksModuleName
>;

export default injectionBase;
